/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var NetDownloadIcon20Solid = forwardRef('NetDownloadIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M10 .75c.69 0 1.25.56 1.25 1.25v9.12l3.544-3.15a1.25 1.25 0 0 1 1.662 1.868l-4.38 3.893a3.125 3.125 0 0 1-4.152 0l-4.38-3.893A1.25 1.25 0 1 1 5.206 7.97l3.545 3.15V2c0-.69.56-1.25 1.25-1.25Z" }),
        React.createElement("path", { d: "M1.75 17c0-.69.56-1.25 1.25-1.25h14a1.25 1.25 0 1 1 0 2.5H3c-.69 0-1.25-.56-1.25-1.25Z" })));
});
